import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AdminPrescriptionsNotePage } from './admin-prescriptions-note';

@NgModule({
  declarations: [
    AdminPrescriptionsNotePage,
  ],
  imports: [
    IonicPageModule.forChild(AdminPrescriptionsNotePage),
  ],
})
export class AdminPrescriptionsNotePageModule {}



// WEBPACK FOOTER //
// ./src/pages/admin-prescriptions-note/admin-prescriptions-note.module.ts